// @mui material components
import {
  Snackbar,
  Alert,
  Grid,
  Card,
  CircularProgress,
  Backdrop,
  Icon,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Tooltip,
  TextField,
  MenuItem,
  Select,
  FormControl,
  InputLabel,
  Button,
  TableRow,
  TableCell,
  Table,
  Divider,
} from "@mui/material";

// Material Dashboard 2 React components
import MDBox from "theme/components/MDBox";
import MDTypography from "theme/components/MDTypography";
import MDInput from "theme/components/MDInput";

// Material Dashboard 2 React example components
import DashboardLayout from "app/LayoutContainers/DashboardLayout";
import DashboardNavbar from "app/Navbars/DashboardNavbar";
import Footer from "theme/Footer";

import { useParams, useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import axios from "axios.js";
import DataTable from "theme/Tables/DataTable";
// import MDBadge from "theme/components/MDBadge";
import MDButton from "theme/components/MDButton";
import usePageTitle from "app/pageTitle";
// import AppConfig from "appConfig";

function LeadBucketViewPage() {
  const pageTitle = "Lead Bucket";
  usePageTitle(pageTitle);
  const { ref } = useParams();
  const navigate = useNavigate();

  const [showLoading, setShowLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const [errorMsg, setErrMsg] = useState("");
  const [severity, setSeverity] = useState("");
  const handleClose = () => {
    setOpen(false);
    setErrMsg("");
  };
  const [openNewCheckDialog, setOpenNewCheckDialog] = useState(false);

  const [refreshPage, setRefreshPage] = useState(false);
  const [leadBucket, setLeadBucket] = useState(null);
  const [customFieldsRaw, setCustomFieldsRaw] = useState([]);
  const [customFieldValues, setCustomFieldValues] = useState({});
  const [leads, setLeads] = useState([]);
  const [campaigns, setCampaigns] = useState([]);

  const [leadName, setLeadName] = useState(null);
  const [leadEmailAddress, setLeadEmailAddress] = useState(null);
  const [leadPhoneNumber, setLeadPhoneNumber] = useState(null);

  const [uploadFile, setUploadFile] = useState(null);
  const [openUploadAgentsDialog, setOpenUploadAgentsDialog] = useState(false);

  const [selectedLead, setSelectedLead] = useState(null);
  const [openSelectedLeadDialog, setOpenSelectedLeadDialog] = useState(false);

  const [agentRef, setAgentRef] = useState(null);
  const [openAssignLeadDialog, setOpenAssignLeadDialog] = useState(false);

  const [ctaCampaigns, setCtaCampaigns] = useState([]);
  const [selectedCTAType, setSelectedCTAType] = useState(null);
  const [selectedCTACampaign, setSelectedCTACampaign] = useState(null);
  const [openCTADialog, setOpenCTADialog] = useState(false);

  const [messageBody, setMessageBody] = useState(null);
  const [messageDelay, setMessageDelay] = useState(false);
  const [messageType, setMessageType] = useState(false);
  const [messageTimeOfDay, setMessageTimeOfDay] = useState(null);
  const [messageInterval, setMessageInterval] = useState(null);
  const [openMessageDialog, setOpenMessageDialog] = useState(false);

  const [groups, setGroups] = useState([]);
  const [agentGroups, setAgentGroups] = useState([]);
  const [selectedAgentGroup, setSelectedAgentGroup] = useState(null);
  const [openAssignGroupDialog, setOpenAssignGroupDialog] = useState(false);

  async function deleteLead(reference) {
    setShowLoading(true);

    await axios
      .get(`portal/leads/buckets/leads/${reference}/delete.json`)
      .then((result) => {
        setShowLoading(false);
        if (result.data.status === "success") {
          setSeverity("success");
          setErrMsg(result.data.data.message);
          setOpen(true);

          setRefreshPage(!refreshPage);
        } else {
          setSeverity("error");
          setErrMsg(result.data.data.message);
          setOpen(true);
        }
      })
      .catch(() => {
        setShowLoading(false);
        setSeverity("error");
        setErrMsg(
          `Unable to complete request. ${
            navigator.onLine ? "" : "Make sure you have an active internet connection"
          }`
        );
        setOpen(true);
      });
  }

  async function unAssignLead(reference) {
    setShowLoading(true);

    await axios
      .get(`portal/leads/buckets/leads/${reference}/unassign.json`)
      .then((result) => {
        setShowLoading(false);
        if (result.data.status === "success") {
          setSeverity("success");
          setErrMsg(result.data.data.message);
          setOpen(true);

          setRefreshPage(!refreshPage);
        } else {
          setSeverity("error");
          setErrMsg(result.data.data.message);
          setOpen(true);
        }
      })
      .catch(() => {
        setShowLoading(false);
        setSeverity("error");
        setErrMsg(
          `Unable to complete request. ${
            navigator.onLine ? "" : "Make sure you have an active internet connection"
          }`
        );
        setOpen(true);
      });
  }

  const leadsColumns = [
    { Header: "Name", accessor: "name", align: "left" },
    { Header: "Email", accessor: "email", align: "left" },
    { Header: "Phone", accessor: "phone", align: "left" },
    { Header: "Assigned To", accessor: "agent", align: "left" },
    { Header: "Actions", accessor: "action", align: "right" },
  ];

  const buildLeadsRows = (data) => {
    const rows = [];
    data.map((row) => {
      rows.push({
        name: row.lead.name,
        email: row.lead.email_address ? row.lead.email_address : "---",
        phone: row.lead.phone_number ? row.lead.phone_number : "---",
        agent: row.agent ? row.agent : "UNASSIGNED",
        action: (
          <MDBox mt={1} variant="button">
            <Tooltip title="View Lead">
              <MDButton
                size="small"
                variant="outlined"
                color="info"
                iconOnly
                onClick={() => {
                  setSelectedLead(row);
                  setOpenSelectedLeadDialog(true);
                }}
              >
                <Icon sx={{ cursor: "pointer" }} fontSize="small" color="dark">
                  visibility
                </Icon>
              </MDButton>
            </Tooltip>
            &nbsp;
            <Tooltip title="Delete Lead">
              <MDButton
                size="small"
                variant="outlined"
                color="error"
                iconOnly
                onClick={() => {
                  if (window.confirm("Delete lead permanently?") === true) {
                    deleteLead(row.lead.reference);
                  }
                }}
              >
                <Icon sx={{ cursor: "pointer" }} fontSize="small" color="dark">
                  delete
                </Icon>
              </MDButton>
            </Tooltip>
          </MDBox>
        ),
        // created: row.created,
      });
      return null;
    });

    return rows;
  };

  async function assignGroup() {
    if (selectedAgentGroup === null) {
      setSeverity("error");
      setErrMsg("An agent group is required.");
      setOpen(true);
      return;
    }

    setOpenAssignGroupDialog(false);
    setShowLoading(true);
    const json = {
      reference: ref,
      group: selectedAgentGroup,
    };

    await axios
      .post("portal/leads/buckets/groups/assign.json", json)
      .then((result) => {
        setShowLoading(false);
        if (result.data.status === "success") {
          setSeverity("success");
          setErrMsg(result.data.data.message);
          setOpen(true);

          setRefreshPage(!refreshPage);
        } else {
          setSeverity("error");
          setErrMsg(result.data.data.message);
          setOpen(true);
        }
      })
      .catch(() => {
        setShowLoading(false);
        setSeverity("error");
        setErrMsg(
          `Unable to complete request. ${
            navigator.onLine ? "" : "Make sure you have an active internet connection"
          }`
        );
        setOpen(true);
      });
  }

  async function deleteGroup(reference) {
    setShowLoading(true);
    await axios
      .get(`portal/leads/buckets/groups/${reference}/delete.json`)
      .then((result) => {
        setShowLoading(false);
        if (result.data.status === "success") {
          setSeverity("success");
          setErrMsg(result.data.data.message);
          setOpen(true);

          setRefreshPage(!refreshPage);
        } else {
          setSeverity("error");
          setErrMsg(result.data.data.message);
          setOpen(true);
        }
      })
      .catch(() => {
        setShowLoading(false);
        setSeverity("error");
        setErrMsg(
          `Unable to complete request. ${
            navigator.onLine ? "" : "Make sure you have an active internet connection"
          }`
        );
        setOpen(true);
      });
  }

  const groupsTableColumns = [
    { Header: "Group", accessor: "group", align: "left" },
    { Header: "Actions", accessor: "action", align: "right" },
  ];

  const buildGroupsRows = (data) => {
    const rows = [];
    data.map((row) => {
      rows.push({
        group: row.title,
        action: (
          <MDBox mt={1} variant="button">
            <Tooltip title="Delete">
              <MDButton
                size="small"
                variant="outlined"
                color="error"
                iconOnly
                onClick={() => {
                  if (window.confirm(`Remove ${row.title}?`) === true) {
                    deleteGroup(row.reference);
                  }
                }}
              >
                <Icon sx={{ cursor: "pointer" }} fontSize="small" color="dark">
                  delete
                </Icon>
              </MDButton>
            </Tooltip>
          </MDBox>
        ),
        created: row.created,
      });
      return null;
    });

    return rows;
  };

  async function deleteBucket(reference) {
    setShowLoading(true);

    await axios
      .get(`portal/leads/buckets/${reference}/delete.json`)
      .then((result) => {
        setShowLoading(false);
        if (result.data.status === "success") {
          setSeverity("success");
          setErrMsg(result.data.data.message);
          setOpen(true);

          setRefreshPage(!refreshPage);
        } else {
          setSeverity("error");
          setErrMsg(result.data.data.message);
          setOpen(true);
        }
      })
      .catch(() => {
        setShowLoading(false);
        setSeverity("error");
        setErrMsg(
          `Unable to complete request. ${
            navigator.onLine ? "" : "Make sure you have an active internet connection"
          }`
        );
        setOpen(true);
      });
  }

  useEffect(() => {
    const fetchData = async () => {
      setShowLoading(true);
      await axios
        .get(`portal/leads/buckets/${ref}/fetch.json`)
        .then((result) => {
          // console.log(result);
          setShowLoading(false);
          if (result.data.status === "success") {
            setLeadBucket(result.data.data.bucket);
            setLeads(result.data.data.leads);
            setCampaigns(result.data.data.campaigns);
            setCustomFieldsRaw(result.data.data.attributes);

            setMessageBody(result.data.data.bucket.message);
            setMessageDelay(result.data.data.bucket.delay);
            let tmpType = false;
            if (result.data.data.bucket.is_repeat) {
              tmpType = true;
            }
            setMessageType(tmpType);
            setMessageInterval(result.data.data.bucket.interval);
            setMessageTimeOfDay(result.data.data.bucket.hour_of_day);

            const rows = buildLeadsRows(result.data.data.leads);
            setLeads(rows);

            setAgentGroups(result.data.data.agent_groups);
            const rowsG = buildGroupsRows(result.data.data.assigned_groups);
            setGroups(rowsG);

            // const rowsF = buildCustomFieldRows(result.data.data.attributes);
            // setCustomFields(rowsF);

            // const rowsL = buildLeadsRows(result.data.data.leads);
            // setLeads(rowsL);
          } else {
            setSeverity("error");
            setErrMsg(result.data.data.message);
            setOpen(true);
          }
        })
        .catch(() => {
          setShowLoading(false);
          setSeverity("error");
          setErrMsg(
            `Unable to complete request. ${
              navigator.onLine ? "" : "Make sure you have an active internet connection"
            }`
          );
          setOpen(true);
        });
    };

    fetchData();
  }, [refreshPage]);

  async function postData(formData) {
    setShowLoading(true);
    await axios
      .post("portal/leads/buckets/leads/upload.json", formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      })
      .then((response) => {
        if (response.data.status === "success") {
          setSeverity("success");
          setErrMsg(response.data.data.message);
          setOpen(true);
          setRefreshPage(!refreshPage);
        } else {
          setSeverity("error");
          setErrMsg(response.data.data.message);
          setOpen(true);
        }
        setShowLoading(false);
      })
      .catch(() => {
        setSeverity("error");
        setErrMsg(
          `Unable to complete request. ${
            navigator.onLine ? "" : "Make sure you have an active internet connection"
          }`
        );
        setOpen(true);
        setShowLoading(false);
      });
  }

  const uploadAgents = () => {
    if (!uploadFile) {
      return;
    }
    const formData = new FormData();
    formData.append("reference", ref);
    formData.append("file", uploadFile);

    // console.log(formData)
    setOpenUploadAgentsDialog(false);
    setShowLoading(true);

    postData(formData);
  };

  function fileSelected(e) {
    e.persist();
    const fileTypes = ["csv"];
    const file = e.target.files[0];
    const extension = file.name.split(".").pop().toLowerCase();
    const supported = fileTypes.indexOf(extension) > -1;
    if (!supported) {
      setSeverity("error");
      setErrMsg("Only excel and csv files accepted.");
      setOpen(true);
      return;
    }
    if (file) {
      const reader = new FileReader();
      reader.onload = (evt) => {
        const csvString = evt.target.result;
        // Process the CSV string to extract headers
        const lines = csvString.split("\n");
        if (lines.length <= 0) {
          setSeverity("error");
          setErrMsg("CSV file is empty.");
          setOpen(true);
          return;
        }

        const headers = lines[0].replace(/\r/g, "").split(","); // Assuming comma delimiter
        // console.log("CSV Headers:", headers);
        if (!headers.includes("name")) {
          setSeverity("error");
          setErrMsg(`"name" is missing in file column headers.`);
          setOpen(true);
          return;
        }

        /* eslint-disable no-restricted-syntax */
        for (const ah of customFieldsRaw) {
          if (!headers.includes(ah.code)) {
            setSeverity("error");
            setErrMsg(`"${ah.code}" is missing in file column headers.`);
            setOpen(true);
            return;
          }
        }
        setUploadFile(e.target.files[0]);
      };
      reader.readAsText(file);
    }
  }

  async function createLead() {
    if (leadName === null || leadName.length <= 0) {
      setSeverity("error");
      setErrMsg("Lead name is required");
      setOpen(true);
      return;
    }

    if (
      (leadEmailAddress === null && leadPhoneNumber === null) ||
      (leadEmailAddress.length <= 0 && leadPhoneNumber.length <= 0)
    ) {
      setSeverity("error");
      setErrMsg("A contact email or phone number is required.");
      setOpen(true);
      return;
    }

    // if (customFieldsRaw.length <= 0) {
    //   setSeverity("error");
    //   setErrMsg("No lead attributes defined.");
    //   setOpen(true);
    //   return;
    // }

    /* eslint-disable no-restricted-syntax */
    for (const f of customFieldsRaw) {
      if (
        typeof customFieldValues[f.reference] === "undefined" ||
        customFieldValues[f.reference].length <= 0
      ) {
        setSeverity("error");
        setErrMsg(`${f.title} is required.`);
        setOpen(true);
        return;
      }
    }

    setOpenNewCheckDialog(false);
    setShowLoading(true);
    const json = {
      reference: leadBucket.reference,
      name: leadName,
      email_address: leadEmailAddress,
      phone_number: leadPhoneNumber,
      attributes: customFieldValues,
    };

    await axios
      .post("portal/leads/buckets/leads/create.json", json)
      .then((result) => {
        setShowLoading(false);
        if (result.data.status === "success") {
          setSeverity("success");
          setErrMsg(result.data.data.message);
          setOpen(true);

          setRefreshPage(!refreshPage);
        } else {
          setSeverity("error");
          setErrMsg(result.data.data.message);
          setOpen(true);
        }
      })
      .catch(() => {
        setShowLoading(false);
        setSeverity("error");
        setErrMsg(
          `Unable to complete request. ${
            navigator.onLine ? "" : "Make sure you have an active internet connection"
          }`
        );
        setOpen(true);
      });
  }

  async function assignLead() {
    if (selectedLead === null) {
      setSeverity("error");
      setErrMsg("Please select a lead to assign.");
      setOpen(true);
      return;
    }

    if (agentRef === null || agentRef.length <= 0) {
      setSeverity("error");
      setErrMsg("Agent is required");
      setOpen(true);
      return;
    }

    setOpenAssignLeadDialog(false);
    setOpenSelectedLeadDialog(false);
    setShowLoading(true);
    const json = {
      reference: selectedLead.reference,
      agent: agentRef,
    };

    await axios
      .post("portal/leads/buckets/leads/assign.json", json)
      .then((result) => {
        setShowLoading(false);
        if (result.data.status === "success") {
          setSeverity("success");
          setErrMsg(result.data.data.message);
          setOpen(true);

          setRefreshPage(!refreshPage);
        } else {
          setSeverity("error");
          setErrMsg(result.data.data.message);
          setOpen(true);
        }
      })
      .catch(() => {
        setShowLoading(false);
        setSeverity("error");
        setErrMsg(
          `Unable to complete request. ${
            navigator.onLine ? "" : "Make sure you have an active internet connection"
          }`
        );
        setOpen(true);
      });
  }

  useEffect(() => {
    if (!selectedCTAType) {
      return;
    }
    setSelectedCTACampaign(null);

    setCtaCampaigns(campaigns[selectedCTAType.toUpperCase()]);
  }, [selectedCTAType]);

  async function setCTA() {
    if (!selectedCTAType) {
      setSeverity("error");
      setErrMsg("Action type is required");
      setOpen(true);
      return;
    }

    if (!selectedCTACampaign) {
      setSeverity("error");
      setErrMsg("Campaign is required");
      setOpen(true);
      return;
    }

    setOpenCTADialog(false);
    setShowLoading(true);
    const json = {
      reference: ref,
      type: selectedCTAType,
      cta: selectedCTACampaign,
    };

    await axios
      .post("portal/leads/buckets/cta/create.json", json)
      .then((result) => {
        setShowLoading(false);
        if (result.data.status === "success") {
          setSeverity("success");
          setErrMsg(result.data.data.message);
          setOpen(true);

          setRefreshPage(!refreshPage);
        } else {
          setSeverity("error");
          setErrMsg(result.data.data.message);
          setOpen(true);
        }
      })
      .catch(() => {
        setShowLoading(false);
        setSeverity("error");
        setErrMsg(
          `Unable to complete request. ${
            navigator.onLine ? "" : "Make sure you have an active internet connection"
          }`
        );
        setOpen(true);
      });
  }

  async function deleteCTA() {
    setShowLoading(true);

    await axios
      .get(`portal/leads/buckets/cta/${ref}/delete.json`)
      .then((result) => {
        setShowLoading(false);
        if (result.data.status === "success") {
          setSeverity("success");
          setErrMsg(result.data.data.message);
          setOpen(true);

          setRefreshPage(!refreshPage);
        } else {
          setSeverity("error");
          setErrMsg(result.data.data.message);
          setOpen(true);
        }
      })
      .catch(() => {
        setShowLoading(false);
        setSeverity("error");
        setErrMsg(
          `Unable to complete request. ${
            navigator.onLine ? "" : "Make sure you have an active internet connection"
          }`
        );
        setOpen(true);
      });
  }

  async function setMessage() {
    if (!messageBody) {
      setSeverity("error");
      setErrMsg("Notification message is required");
      setOpen(true);
      return;
    }

    if (messageType === null) {
      setSeverity("error");
      setErrMsg("Notification type is requiredd");
      setOpen(true);
      return;
    }

    if (messageType === true) {
      if (!messageTimeOfDay) {
        setSeverity("error");
        setErrMsg("Notification hour is required");
        setOpen(true);
        return;
      }
      if (!messageInterval) {
        setSeverity("error");
        setErrMsg("Notification interval is required");
        setOpen(true);
        return;
      }
    }

    setOpenMessageDialog(false);
    setShowLoading(true);
    const json = {
      reference: ref,
      message: messageBody,
      type: messageType,
      delay: messageDelay,
      hour_of_day: messageTimeOfDay ? parseInt(messageTimeOfDay, 10) : null,
      interval: messageInterval,
    };

    await axios
      .post("portal/leads/buckets/notification/create.json", json)
      .then((result) => {
        setShowLoading(false);
        if (result.data.status === "success") {
          setSeverity("success");
          setErrMsg(result.data.data.message);
          setOpen(true);

          setRefreshPage(!refreshPage);
        } else {
          setSeverity("error");
          setErrMsg(result.data.data.message);
          setOpen(true);
        }
      })
      .catch(() => {
        setShowLoading(false);
        setSeverity("error");
        setErrMsg(
          `Unable to complete request. ${
            navigator.onLine ? "" : "Make sure you have an active internet connection"
          }`
        );
        setOpen(true);
      });
  }

  async function removeMessage() {
    setOpenMessageDialog(false);
    setShowLoading(true);

    await axios
      .get(`portal/leads/buckets/notification/${ref}/delete.json`)
      .then((result) => {
        setShowLoading(false);
        if (result.data.status === "success") {
          setSeverity("success");
          setErrMsg(result.data.data.message);
          setOpen(true);

          setRefreshPage(!refreshPage);
        } else {
          setSeverity("error");
          setErrMsg(result.data.data.message);
          setOpen(true);
        }
      })
      .catch(() => {
        setShowLoading(false);
        setSeverity("error");
        setErrMsg(
          `Unable to complete request. ${
            navigator.onLine ? "" : "Make sure you have an active internet connection"
          }`
        );
        setOpen(true);
      });
  }

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={showLoading}
        onClick={handleClose}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      <Snackbar
        open={open}
        autoHideDuration={6000}
        onClose={handleClose}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Alert onClose={handleClose} severity={severity} sx={{ width: "100%" }}>
          {errorMsg}
        </Alert>
      </Snackbar>
      <Dialog open={openNewCheckDialog} fullWidth maxWidth="xs">
        <DialogTitle>
          <MDBox>New Lead</MDBox>
        </DialogTitle>
        <DialogContent>
          <MDBox>
            <MDBox mt={0}>
              <MDInput
                margin="dense"
                label="Name"
                type="text"
                fullWidth
                variant="outlined"
                onChange={(e) => {
                  setLeadName(e.target.value);
                }}
              />
            </MDBox>
            <MDBox mt={2}>
              <MDInput
                margin="dense"
                label="Email Address (Optional)"
                type="text"
                fullWidth
                variant="outlined"
                onChange={(e) => {
                  setLeadEmailAddress(e.target.value);
                }}
              />
            </MDBox>
            <MDBox mt={2}>
              <MDInput
                margin="dense"
                label="Phone Number (Optional)"
                type="text"
                fullWidth
                variant="outlined"
                onChange={(e) => {
                  setLeadPhoneNumber(e.target.value);
                }}
              />
            </MDBox>
            {customFieldsRaw.length > 0 && (
              <MDBox mb={5}>
                {customFieldsRaw.map((cField) => {
                  if (cField.options.length > 0) {
                    return (
                      <MDBox mt={3}>
                        <FormControl sx={{ minWidth: 120, width: "100%" }}>
                          <InputLabel>{cField.title}</InputLabel>
                          <Select
                            label={cField.title}
                            sx={{ padding: "12px", paddingLeft: "3px" }}
                            onChange={(e) => {
                              const tmp = customFieldValues;
                              tmp[cField.reference] = e.target.value;
                              // console.log(tmp);
                              setCustomFieldValues(tmp);
                            }}
                          >
                            {cField.options.map((opt) => (
                              <MenuItem value={opt}>{opt}</MenuItem>
                            ))}
                          </Select>
                        </FormControl>
                      </MDBox>
                    );
                  }

                  return (
                    <MDBox mt={2}>
                      <MDInput
                        margin="dense"
                        label={cField.title}
                        type="text"
                        fullWidth
                        variant="outlined"
                        onChange={(e) => {
                          const tmp = customFieldValues;
                          tmp[cField.reference] = e.target.value;
                          // console.log(tmp);
                          setCustomFieldValues(tmp);
                        }}
                      />
                    </MDBox>
                  );
                })}
              </MDBox>
            )}
          </MDBox>
        </DialogContent>
        <DialogActions>
          <MDButton
            onClick={() => {
              setOpenNewCheckDialog(false);
            }}
            color="dark"
            variant="outlined"
          >
            Cancel
          </MDButton>
          <MDButton
            color="info"
            variant="outlined"
            onClick={() => {
              createLead();
            }}
          >
            Add Lead
          </MDButton>
        </DialogActions>
      </Dialog>
      <Dialog open={openUploadAgentsDialog} fullWidth maxWidth="xs">
        <DialogTitle>
          <MDBox>Upload Leads</MDBox>
        </DialogTitle>
        <DialogContent>
          <MDBox mt={2} mb={3}>
            <MDBox mt={1}>
              <TextField
                accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                type="file"
                name="upload_file"
                id="upload_file"
                // onChange={handleFileInputChange}
                onChange={(e) => fileSelected(e)}
                fullWidth
              />
            </MDBox>
            <MDBox mt={3}>
              <Alert severity="info">
                <MDTypography variant="subtitle2" fontSize={14}>
                  <b>Important!</b>
                  <br />- File must contain a <b>name</b> column.
                  <br />- File must contain <b>email_address</b> and/or <b>phone_number</b> columns.
                  <br />- Use profile attribute <b>keys</b> as columns.
                </MDTypography>
              </Alert>
            </MDBox>
          </MDBox>
        </DialogContent>
        <DialogActions>
          <MDButton
            onClick={() => {
              setOpenUploadAgentsDialog(false);
            }}
            color="dark"
            variant="outlined"
          >
            Cancel
          </MDButton>
          <MDButton
            color="info"
            variant="outlined"
            onClick={() => {
              uploadAgents();
            }}
          >
            Upload Leads
          </MDButton>
        </DialogActions>
      </Dialog>
      {selectedLead && (
        <Dialog open={openSelectedLeadDialog} fullWidth maxWidth="sm">
          <DialogTitle>
            <MDBox display="flex" justifyContent="space-between">
              <MDBox>{selectedLead.lead.name}</MDBox>
              <MDBox>
                <MDButton
                  onClick={() => {
                    setOpenSelectedLeadDialog(false);
                  }}
                  color="dark"
                  variant="outlined"
                  iconOnly
                  circular
                  size="small"
                >
                  <Icon>clear</Icon>
                </MDButton>
              </MDBox>
            </MDBox>
          </DialogTitle>
          <DialogContent>
            <MDBox mt={0} mb={3}>
              <Table>
                <TableRow>
                  <TableCell>
                    <MDTypography variant="subtitle2" fontSize={14}>
                      Email Address:
                    </MDTypography>
                  </TableCell>
                  <TableCell align="right">
                    <MDTypography variant="subtitle2" fontSize={14}>
                      <b>
                        {selectedLead.lead.email_address ? selectedLead.lead.email_address : "---"}
                      </b>
                    </MDTypography>
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell>
                    <MDTypography variant="subtitle2" fontSize={14}>
                      Phone Number:
                    </MDTypography>
                  </TableCell>
                  <TableCell align="right">
                    <MDTypography variant="subtitle2" fontSize={14}>
                      <b>
                        {selectedLead.lead.phone_number ? selectedLead.lead.phone_number : "---"}
                      </b>
                    </MDTypography>
                  </TableCell>
                </TableRow>

                {selectedLead.lead.attributes.map((attribute) => (
                  <TableRow>
                    <TableCell>
                      <MDTypography variant="subtitle2" fontSize={14}>
                        {attribute.name}:
                      </MDTypography>
                    </TableCell>
                    <TableCell align="right">
                      <MDTypography variant="subtitle2" fontSize={14}>
                        <b>{attribute.value}</b>
                      </MDTypography>
                    </TableCell>
                  </TableRow>
                ))}
              </Table>
              <MDBox m={3} align="center">
                <MDTypography variant="h6" fontSize={14} fontWeight="regular">
                  Assigned Agent:
                  <br />
                  <b>{selectedLead.agent ? selectedLead.agent : `N/A`}</b>
                </MDTypography>
              </MDBox>
            </MDBox>
          </DialogContent>
          <DialogActions>
            {selectedLead.agent && (
              <MDButton
                onClick={() => {
                  setOpenSelectedLeadDialog(false);
                  unAssignLead(selectedLead.reference);
                }}
                color="error"
                variant="outlined"
              >
                Un-assign
              </MDButton>
            )}
            <MDButton
              onClick={() => {
                setOpenAssignLeadDialog(true);
              }}
              color="info"
              variant="outlined"
            >
              {selectedLead.agent ? "Re-Assign?" : "Assign"}
            </MDButton>
          </DialogActions>
        </Dialog>
      )}

      <Dialog open={openAssignLeadDialog} fullWidth maxWidth="xs">
        <DialogTitle>
          <MDBox>Assign Lead</MDBox>
        </DialogTitle>
        <DialogContent>
          <MDBox>
            <MDBox mt={0}>
              <MDInput
                margin="dense"
                label="Agent"
                placeholder="Staff Number, email or phone number"
                type="text"
                fullWidth
                variant="outlined"
                onChange={(e) => {
                  setAgentRef(e.target.value);
                }}
              />
            </MDBox>
          </MDBox>
        </DialogContent>
        <DialogActions>
          <MDButton
            onClick={() => {
              setOpenAssignLeadDialog(false);
            }}
            color="dark"
            variant="outlined"
          >
            Cancel
          </MDButton>
          <MDButton
            color="info"
            variant="outlined"
            onClick={() => {
              assignLead();
            }}
          >
            Assign
          </MDButton>
        </DialogActions>
      </Dialog>

      <Dialog open={openCTADialog} fullWidth maxWidth="xs">
        <DialogTitle>
          <MDBox>Set CTA</MDBox>
        </DialogTitle>
        <DialogContent>
          <MDBox mt={1} mb={3}>
            <MDBox>
              <FormControl sx={{ minWidth: 120, width: "100%" }}>
                <InputLabel>Action Type</InputLabel>
                <Select
                  label="Action Type"
                  sx={{ padding: "12px", paddingLeft: "3px" }}
                  onChange={(e) => {
                    setSelectedCTAType(e.target.value);
                  }}
                >
                  <MenuItem value="SALES">Sales</MenuItem>
                  <MenuItem value="DATA">Data Capture</MenuItem>
                </Select>
              </FormControl>
            </MDBox>
            {selectedCTAType && (
              <MDBox mt={5}>
                <FormControl sx={{ minWidth: 120, width: "100%" }}>
                  <InputLabel>Select Campaign</InputLabel>
                  <Select
                    label="Select Campaign"
                    sx={{ padding: "12px", paddingLeft: "3px" }}
                    onChange={(e) => {
                      setSelectedCTACampaign(e.target.value);
                    }}
                  >
                    {ctaCampaigns.map((campaign) => (
                      <MenuItem value={campaign.reference}>{campaign.title}</MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </MDBox>
            )}
          </MDBox>
        </DialogContent>
        <DialogActions>
          <MDButton
            onClick={() => {
              setOpenCTADialog(false);
            }}
            color="dark"
            variant="outlined"
          >
            Cancel
          </MDButton>
          <MDButton
            color="info"
            variant="outlined"
            onClick={() => {
              setCTA();
            }}
          >
            Set
          </MDButton>
        </DialogActions>
      </Dialog>

      <Dialog open={openAssignGroupDialog} fullWidth maxWidth="xs">
        <DialogTitle>
          <MDBox>Assign Agent Group</MDBox>
        </DialogTitle>
        <DialogContent>
          <MDBox sx={{ marginTop: "15px" }}>
            <MDBox mt={2}>
              <FormControl sx={{ minWidth: 120, width: "100%" }}>
                <InputLabel>Agent Group</InputLabel>
                <Select
                  label="Agent Group"
                  onChange={(e) => {
                    setSelectedAgentGroup(e.target.value);
                  }}
                  sx={{ padding: "12px", paddingLeft: "3px" }}
                >
                  {
                    // --> Notice below changes
                    agentGroups.length > 0 && // --> Changes from `options.length ? ...` to `options.length > 0 && ...`
                      agentGroups.map((record) => (
                        <MenuItem value={`${record.reference}`}>{record.title}</MenuItem>
                      ))
                  }
                </Select>
              </FormControl>
            </MDBox>
          </MDBox>
        </DialogContent>
        <DialogActions>
          <MDButton
            onClick={() => {
              setOpenAssignGroupDialog(false);
            }}
            color="dark"
            variant="outlined"
          >
            Cancel
          </MDButton>
          <MDButton
            color="info"
            variant="outlined"
            onClick={() => {
              assignGroup();
            }}
          >
            Add
          </MDButton>
        </DialogActions>
      </Dialog>

      {leadBucket && (
        <Dialog open={openMessageDialog} fullWidth maxWidth="sm">
          <DialogTitle>
            <MDBox display="flex" justifyContent="space-between">
              <MDBox>Notification Message</MDBox>
              <MDBox>
                <MDButton
                  onClick={() => {
                    setOpenMessageDialog(false);
                  }}
                  color="dark"
                  variant="outlined"
                  iconOnly
                  circular
                  size="small"
                >
                  <Icon>clear</Icon>
                </MDButton>
              </MDBox>
            </MDBox>
          </DialogTitle>
          <DialogContent>
            <MDBox mt={1}>
              <MDBox>
                <MDInput
                  margin="dense"
                  label="Notification Message"
                  value={messageBody}
                  type="text"
                  multiline
                  minRows={3}
                  fullWidth
                  variant="outlined"
                  onChange={(e) => {
                    setMessageBody(e.target.value);
                  }}
                />
                <MDBox mt={1}>
                  <Alert severity="info">
                    <MDTypography variant="subtitle2" fontSize={12}>
                      Customise your message with lead profile name and/or attribute keys. Ex;{" "}
                      {`{{NAME}}, {{ADDRESS}} etc`}
                    </MDTypography>
                  </Alert>
                </MDBox>
              </MDBox>
              <MDBox>
                <Divider />
              </MDBox>
              <MDBox mt={3}>
                <FormControl sx={{ minWidth: 120, width: "100%" }}>
                  <InputLabel>Notification Type</InputLabel>
                  <Select
                    label="Notification Type"
                    sx={{ padding: "12px", paddingLeft: "3px" }}
                    onChange={(e) => {
                      let val = false;
                      if (e.target.value === 1) {
                        val = true;
                      }
                      setMessageType(val);
                    }}
                    value={messageType ? 1 : 0}
                  >
                    <MenuItem value={0}>One-Off</MenuItem>
                    <MenuItem value={1}>Repeat</MenuItem>
                  </Select>
                </FormControl>
              </MDBox>
              {!messageType ? (
                <MDBox mt={3}>
                  <MDInput
                    margin="dense"
                    label="Delay in Days (Optional)"
                    value={messageDelay}
                    type="number"
                    fullWidth
                    variant="outlined"
                    onChange={(e) => {
                      setMessageDelay(e.target.value);
                    }}
                  />
                </MDBox>
              ) : (
                <MDBox mt={3}>
                  <Grid container spacing={3}>
                    <Grid item xs={12} md={6} lg={6}>
                      <MDBox mt={1}>
                        <FormControl sx={{ minWidth: 120, width: "100%" }}>
                          <InputLabel>Notification Hour</InputLabel>
                          <Select
                            label="Notification Hour"
                            sx={{ padding: "12px", paddingLeft: "3px" }}
                            onChange={(e) => {
                              setMessageTimeOfDay(e.target.value);
                            }}
                            value={messageTimeOfDay}
                          >
                            <MenuItem value="00:00">12:00 am</MenuItem>
                            <MenuItem value="1:00">1:00 am</MenuItem>
                            <MenuItem value="2:00">2:00 am</MenuItem>
                            <MenuItem value="3:00">3:00 am</MenuItem>
                            <MenuItem value="4:00">4:00 am</MenuItem>
                            <MenuItem value="5:00">5:00 am</MenuItem>
                            <MenuItem value="6:00">6:00 am</MenuItem>
                            <MenuItem value="7:00">7:00 am</MenuItem>
                            <MenuItem value="8:00">8:00 am</MenuItem>
                            <MenuItem value="9:00">9:00 am</MenuItem>
                            <MenuItem value="10:00">10:00 am</MenuItem>
                            <MenuItem value="11:00">11:00 am</MenuItem>
                            <MenuItem value="12:00">12:00 pm</MenuItem>
                            <MenuItem value="13:00">1:00 pm</MenuItem>
                            <MenuItem value="14:00">2:00 pm</MenuItem>
                            <MenuItem value="15:00">3:00 pm</MenuItem>
                            <MenuItem value="16:00">4:00 pm</MenuItem>
                            <MenuItem value="17:00">5:00 pm</MenuItem>
                            <MenuItem value="18:00">6:00 pm</MenuItem>
                            <MenuItem value="19:00">7:00 pm</MenuItem>
                            <MenuItem value="20:00">8:00 pm</MenuItem>
                            <MenuItem value="21:00">9:00 pm</MenuItem>
                            <MenuItem value="22:00">10:00 pm</MenuItem>
                            <MenuItem value="23:00">11:00 pm</MenuItem>
                          </Select>
                        </FormControl>
                      </MDBox>
                    </Grid>
                    <Grid item xs={12} md={6} lg={6}>
                      <MDBox>
                        <MDInput
                          margin="dense"
                          label="Notification Interval (Days)"
                          value={messageInterval}
                          type="number"
                          fullWidth
                          variant="outlined"
                          onChange={(e) => {
                            setMessageInterval(e.target.value);
                          }}
                        />
                      </MDBox>
                    </Grid>
                  </Grid>
                </MDBox>
              )}
            </MDBox>
          </DialogContent>
          <DialogActions>
            {leadBucket.message && (
              <MDButton
                onClick={() => {
                  removeMessage();
                }}
                color="error"
                variant="contained"
              >
                Delete
              </MDButton>
            )}
            <MDButton
              color="info"
              variant="outlined"
              onClick={() => {
                setMessage();
              }}
            >
              {leadBucket.message ? "Update" : "Set"}
            </MDButton>
          </DialogActions>
        </Dialog>
      )}

      {leadBucket !== null && (
        <MDBox pt={3} pb={3}>
          <MDBox mt={0} mb={1.5} display="flex" justifyContent="space-between">
            <MDBox>
              <Button
                color="dark"
                size="small"
                startIcon={<Icon>west</Icon>}
                onClick={() => {
                  navigate(`/lead-profiles/${leadBucket.type.reference}`);
                }}
              >
                Back
              </Button>
            </MDBox>
          </MDBox>
          <MDBox>
            <Grid container spacing={2}>
              <Grid item xs={12} md={8} lg={8}>
                <Card sx={{ height: "100%", marginTop: "0px" }}>
                  <MDBox p={2}>
                    <MDBox display="flex" justifyContent="space-between" alignItems="center">
                      <MDBox>
                        <MDTypography variant="h6" fontWeight="light" fontSize={12}>
                          ID: {leadBucket.reference}
                        </MDTypography>
                        <MDTypography variant="h6" fontWeight="medium" fontSize={14}>
                          {leadBucket.title}
                        </MDTypography>
                      </MDBox>
                      <MDBox mt={-1}>
                        <Tooltip title="Delete Bucket">
                          <MDButton
                            variant="contained"
                            color="error"
                            iconOnly
                            onClick={() => {
                              if (
                                window.confirm(
                                  "Delete Bucket? All related saved records will be deleted permanently!"
                                ) === true
                              ) {
                                deleteBucket(ref);
                              }
                            }}
                            size="small"
                          >
                            <Icon sx={{ cursor: "pointer" }} fontSize="small" color="dark">
                              delete
                            </Icon>
                          </MDButton>
                        </Tooltip>
                      </MDBox>
                    </MDBox>
                  </MDBox>
                </Card>
              </Grid>
              <Grid item xs={12} md={4} lg={4}>
                <Card sx={{ height: "100%", marginTop: "0px" }}>
                  <MDBox p={2} align="center">
                    <MDBox>
                      <MDTypography variant="h6" fontWeight="light">
                        Leads
                      </MDTypography>
                    </MDBox>
                    <MDBox mt={2}>
                      <MDTypography variant="h6" fontWeight="medium" fontSize={18}>
                        {leads.length}
                      </MDTypography>
                    </MDBox>
                  </MDBox>
                </Card>
              </Grid>
            </Grid>
          </MDBox>
          <MDBox mt={3}>
            <Grid container spacing={3}>
              <Grid item xs={12} md={7} lg={7}>
                <MDBox>
                  <Card sx={{ height: "100%", marginTop: "0px" }}>
                    <MDBox p={2}>
                      <MDBox align="center">
                        <MDTypography variant="h6" fontWeight="medium">
                          Message Assistant
                        </MDTypography>
                      </MDBox>
                      <MDBox>
                        <Divider />
                      </MDBox>
                      <MDBox mt={2}>
                        {leadBucket.message ? (
                          <MDBox>
                            <MDBox mt={0} mb={2}>
                              <MDBox mb={1} display="flex" justifyContent="space-between">
                                <MDBox>
                                  <MDTypography
                                    mb={1}
                                    variant="h6"
                                    fontSize={14}
                                    fontWeight="regular"
                                  >
                                    Notification
                                  </MDTypography>
                                </MDBox>
                                <MDBox>
                                  <MDButton
                                    variant="outlined"
                                    color="warning"
                                    iconOnly
                                    onClick={() => setOpenMessageDialog(true)}
                                    size="small"
                                  >
                                    <Icon sx={{ cursor: "pointer" }} fontSize="small">
                                      edit
                                    </Icon>
                                  </MDButton>
                                </MDBox>
                              </MDBox>
                              <MDTypography variant="subtitle2" fontSize={14}>
                                {leadBucket.message}
                              </MDTypography>
                            </MDBox>
                            {leadBucket.is_repeat ? (
                              <MDBox mt={1}>
                                <MDTypography
                                  mb={0.5}
                                  variant="h6"
                                  fontSize={14}
                                  fontWeight="regular"
                                >
                                  Repeat
                                </MDTypography>
                                <MDTypography variant="subtitle2" fontSize={14}>
                                  At {leadBucket.hour_of_day}{" "}
                                  {leadBucket.interval > 1
                                    ? `every ${leadBucket.interval} days`
                                    : "daily"}
                                </MDTypography>
                              </MDBox>
                            ) : (
                              <MDBox mt={1}>
                                <MDTypography
                                  mb={0.5}
                                  variant="h6"
                                  fontSize={14}
                                  fontWeight="regular"
                                >
                                  Trigger
                                </MDTypography>
                                <MDTypography variant="subtitle2" fontSize={14}>
                                  {leadBucket.delay
                                    ? `Delay by ${leadBucket.delay} day(s).`
                                    : `Send immediately`}
                                </MDTypography>
                              </MDBox>
                            )}
                          </MDBox>
                        ) : (
                          <MDBox mt={1} align="center">
                            <MDTypography mb={2} variant="h6" fontWeight="light" fontSize={14}>
                              Configure auto messaging to leads. Set up instant, delayed or repeat
                              CTA notifications via EMAIL and SMS. Customize your message with
                              profile attributes.
                            </MDTypography>
                            <MDButton
                              variant="contained"
                              color="dark"
                              onClick={() => setOpenMessageDialog(true)}
                              size="small"
                              startIcon={
                                <Icon sx={{ cursor: "pointer" }} fontSize="small" color="dark">
                                  message
                                </Icon>
                              }
                            >
                              Set Notification
                            </MDButton>
                          </MDBox>
                        )}
                      </MDBox>
                    </MDBox>
                  </Card>
                </MDBox>
              </Grid>
              <Grid item xs={12} md={5} lg={5}>
                <MDBox sx={{ height: "100%", marginTop: "0px" }}>
                  <Card sx={{ height: "100%", marginTop: "0px" }}>
                    <MDBox p={2.5}>
                      <MDBox mt={0}>
                        <MDBox align="center">
                          <MDTypography variant="h6" fontWeight="bold" fontSize={14}>
                            Call To Action (CTA)
                          </MDTypography>
                        </MDBox>
                        <MDBox>
                          <Divider />
                        </MDBox>
                        {leadBucket.cta ? (
                          <MDBox
                            mt={3}
                            display="flex"
                            justifyContent="space-between"
                            alignItems="center"
                          >
                            <MDBox>
                              <MDTypography variant="h6" fontWeight="light">
                                <small>{leadBucket.cta.type}</small>
                                <br />
                                <b>{leadBucket.cta.title}</b>
                              </MDTypography>
                            </MDBox>
                            <MDBox>
                              <Tooltip title="Delete CTA">
                                <MDButton
                                  variant="outlined"
                                  color="error"
                                  iconOnly
                                  onClick={() => {
                                    if (window.confirm("Delete CTA?") === true) {
                                      deleteCTA();
                                    }
                                  }}
                                  size="small"
                                >
                                  <Icon sx={{ cursor: "pointer" }} fontSize="small" color="dark">
                                    remove
                                  </Icon>
                                </MDButton>
                              </Tooltip>
                            </MDBox>
                          </MDBox>
                        ) : (
                          <MDBox mt={1} align="center">
                            <MDTypography mb={2} variant="h6" fontWeight="light" fontSize={14}>
                              Set a conversion action for this bucket.
                            </MDTypography>
                            <MDButton
                              variant="contained"
                              color="dark"
                              onClick={() => {
                                setSelectedCTAType(null);
                                setOpenCTADialog(true);
                              }}
                              size="small"
                              startIcon={
                                <Icon sx={{ cursor: "pointer" }} fontSize="small" color="dark">
                                  add
                                </Icon>
                              }
                            >
                              Set CTA
                            </MDButton>
                          </MDBox>
                        )}
                      </MDBox>
                    </MDBox>
                  </Card>
                </MDBox>
              </Grid>
            </Grid>
          </MDBox>
          <MDBox mt={5}>
            {groups.length > 0 ? (
              <MDBox>
                <Card sx={{ height: "100%", marginTop: "0px" }}>
                  <MDBox>
                    <MDBox>
                      <MDBox
                        display="flex"
                        justifyContent="space-between"
                        alignItems="center"
                        p={2}
                      >
                        <MDTypography variant="h6" fontWeight="light">
                          <b>Agent Groups</b>
                        </MDTypography>
                        <MDButton
                          variant="contained"
                          color="dark"
                          size="small"
                          iconOnly
                          onClick={() => {
                            setSelectedAgentGroup(null);
                            setOpenAssignGroupDialog(true);
                          }}
                        >
                          <Icon sx={{ fontWeight: "bold" }}>add</Icon>
                        </MDButton>
                      </MDBox>
                    </MDBox>
                    <MDBox>
                      <DataTable
                        table={{ columns: groupsTableColumns, rows: groups }}
                        isSorted
                        entriesPerPage={false}
                        showTotalEntries
                        canSearch={false}
                        buttons
                        noEndBorder
                      />
                    </MDBox>
                  </MDBox>
                </Card>
              </MDBox>
            ) : (
              <MDBox>
                <Card sx={{ height: "100%", marginTop: "0px" }}>
                  <MDBox>
                    <MDBox align="center">
                      <MDBox p={2}>
                        <MDTypography variant="h6" fontSize={48}>
                          <Icon>groups</Icon>
                        </MDTypography>
                        <MDTypography variant="h6" fontWeight="light" fontSize={16}>
                          Assign teams to your buckets.
                        </MDTypography>
                      </MDBox>
                      <MDBox mt={3} mb={3}>
                        <MDButton
                          variant="contained"
                          size="small"
                          color="dark"
                          onClick={() => {
                            setSelectedAgentGroup(null);
                            setOpenAssignGroupDialog(true);
                          }}
                          startIcon={<Icon>add</Icon>}
                        >
                          Add Group
                        </MDButton>
                      </MDBox>
                    </MDBox>
                  </MDBox>
                </Card>
              </MDBox>
            )}
          </MDBox>
          <MDBox mt={5}>
            <Card sx={{ height: "100%", marginTop: "0px" }}>
              <MDBox>
                <MDBox p={2} display="flex" justifyContent="space-between" alignItems="center">
                  <MDBox>
                    <MDTypography variant="h6" fontWeight="medium">
                      Leads
                    </MDTypography>
                  </MDBox>
                  <MDBox>
                    <MDBox>
                      <Tooltip title="Add Lead">
                        <MDButton
                          variant="contained"
                          color="dark"
                          iconOnly
                          onClick={() => {
                            setCustomFieldValues({});
                            setOpenNewCheckDialog(true);
                          }}
                          size="small"
                        >
                          <Icon sx={{ fontWeight: "bold" }}>add</Icon>
                        </MDButton>
                      </Tooltip>
                      &nbsp;
                      <Tooltip title="Upload Leads">
                        <MDButton
                          variant="outlined"
                          color="dark"
                          iconOnly
                          onClick={() => {
                            setOpenUploadAgentsDialog(true);
                          }}
                          size="small"
                        >
                          <Icon sx={{ fontWeight: "bold" }}>upload</Icon>
                        </MDButton>
                      </Tooltip>
                    </MDBox>
                  </MDBox>
                </MDBox>
                <MDBox mt={1}>
                  <DataTable
                    table={{ columns: leadsColumns, rows: leads }}
                    isSorted
                    // canSearch={false}
                    entriesPerPage={false}
                    showTotalEntries
                    noEndBorder
                  />
                </MDBox>
              </MDBox>
            </Card>
          </MDBox>
        </MDBox>
      )}

      <Footer />
    </DashboardLayout>
  );
}

export default LeadBucketViewPage;
